/**
 * Safely opens a URL in a new window/tab, handling Safari's popup blocking
 * @param {string} url - The URL to open
 * @param {string} target - The target window name (default: '_blank')
 * @returns {Window|null} The opened window object or null if blocked
 */
export const safeWindowOpen = (url, target = '_blank') => {
  // For Safari on iOS, try using a direct link first
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    const link = document.createElement('a');
    link.href = url;
    link.target = target;
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return null;
  }

  // For other browsers, try window.open
  const newWindow = window.open(url, target);
  if (newWindow) {
    newWindow.focus();
  }
  return newWindow;
};
